export enum ReportType {
  Pdf,
  Excel,
}
